const navSlide = () => {
    $(".burger").on("click", function() {
        $(".nav-mobile ").toggleClass("active");
        $(this).toggleClass("active");
        $("body").toggleClass("disabled");
        // $('.nav-link').toggleClass('active');
    });
};

function sticky_mtt() {
    if ($(window).width() >= 1024) {
        $(".orthernews-wrapper").sticky({
            topSpacing: $("header").outerHeight(),
            zIndex: -1,
            topSpacing: 170,
        });
    }
}

// Add smooth scrolling to all links
function scrollToDiv() {
    $("#mtt_scroll a").on("click", function(event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            $("html, body").animate({
                    scrollTop: $(hash).offset().top - $("header").outerHeight() - 50,
                },
                "slow"
            );
        }
    });
}

//Header when scroll
const checkScroll = () => {
    var lastScrollTop = 0;

    $(window).scroll(function(event) {
        if (window.pageYOffset > 130) {
            var checkScroll = $(this).scrollTop();
            if (checkScroll > lastScrollTop) {
                $("header").addClass("header-scroll");
            } else {
                $("header").removeClass("header-scroll");
            }
            lastScrollTop = checkScroll;
        }
    });
};
// Collapse Solution List
const collapse = () => {
    $(".collapse-body-item .title").click(function() {
        $(this).addClass("active");
        $(this).siblings(".content").slideDown();
    });
    $(".collapse-body-item .title")
        .not(this)
        .parent(".collapse-body-item")
        .find(".content")
        .slideUp();
    // $('.collapse-header').click(function() {
    // var title = $(this);
    // var parent = title.parent('.collapse-items');
    // var list = title.siblings('.collapse-body');
    // if (parent.hasClass('is-open')) {
    // list.slideUp('slow');
    // parent.removeClass('is-open');
    // } else {
    // list.slideDown('slow');
    // parent.addClass('is-open');
    // }
    // });
};

//Slide banner
function CrMainBanner() {
    // Home Banner
    var homebanner_slide = new Swiper("#home-banner .swiper-container", {
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: {
            el: "#home-banner  .swiper-pagination",
        },
    });
    var pages_slide = new Swiper("#page-banner .swiper-container", {
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: {
            el: "#page-banner .swiper-pagination",
        },
    });
    //Index
    var index_1 = new Swiper(".index-1-slide .swiper-container", {
        slidesPerView: 4,
        spaceBetween: 10,
        grabCursor: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        breakpoints: {
            575: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
        navigation: {
            nextEl: ".index-1-slide .swiper-button-next",
            prevEl: ".index-1-slide .swiper-button-prev",
        },
    });
    var index_4 = new Swiper(".index-4-slide .swiper-container", {
        slidesPerView: 5,
        spaceBetween: 30,
        autoplay: {
            delay: 3000,
        },
        grabCursor: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            1440: {
                slidesPerView: 4.5,
            },
        },
        navigation: {
            nextEl: ".index-4-slide .swiper-button-next",
            prevEl: ".index-4-slide .swiper-button-prev",
        },
    });
    //Product
    var product_gallery_thumbs = new Swiper(
        ".product-detail-slide .product-gallery-thumbs ", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
        }
    );
    var product_gallery_top = new Swiper(
        ".product-detail-slide .product-gallery-top", {
            spaceBetween: 10,
            navigation: {
                nextEl: ".product-detail-slide .swiper-button-next",
                prevEl: ".product-detail-slide .swiper-button-prev",
            },
            thumbs: {
                swiper: product_gallery_thumbs,
            },
        }
    );
    var page_product_detail_2_slide = new Swiper(
        ".pages-product-detail-2-slide .swiper-container", {
            slidesPerView: 4,
            spaceBetween: 30,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                1440: {
                    slidesPerView: 3.5,
                },
            },
            navigation: {
                nextEl: ".pages-product-detail-2-slide .swiper-button-next",
                prevEl: ".pages-product-detail-2-slide .swiper-button-prev",
            },
        }
    );
    var galleryThumbs = new Swiper(".gallery-thumbs", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            1200: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
        },
    });

    var galleryTop = new Swiper(".gallery-top", {
        spaceBetween: 10,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: galleryThumbs,
        },
    });
    var galleryTop = new Swiper(".gallery-top", {
        loop: true,
        spaceBetween: 10,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".box-large.lnr.lnr-arrow-next",
            prevEl: ".box-large.lnr.lnr-arrow-prev",
        },
        thumbs: {
            swiper: galleryThumbs,
        },
    });

    var swiper = new Swiper(".slide-box.swiper-container", {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 1,
            },
        },
    });
    var swiper = new Swiper(".slide-services-detail.swiper-container", {
        slidesPerView: 2,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".services-detail.lnr.lnr-arrow-next",
            prevEl: ".services-detail.lnr.lnr-arrow-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 1,
            },
        },
    });
}
//Check banner
const checkLayoutBanner = () => {
    if ($(window).width() < 1280) {
        var header = $("header").outerHeight();
        $("main").css("padding-top", header);
    }
};

function phantrang() {
    $(".modulepager")
        .find(".pagination")
        .find("li>a.NextPage, li>a.LastPage, li>a.BackPage, li>a.FirstPage")
        .parent()
        .hide();
}

function showBackToTop() {
    var heightTop = $("header").outerHeight() + $("#home-banner").outerHeight();
    var heightPageTop =
        $("header").outerHeight() + $("#page-banner").outerHeight();
    $(window).scroll(function() {
        if (
            $(this).scrollTop() > heightTop ||
            $(this).scrollTop() > heightPageTop
        ) {
            $("#back-to-top").addClass("active");
        } else {
            $("#back-to-top").removeClass("active");
        }
    });

    $("#back-to-top").on("click", function(e) {
        e.preventDefault();
        $("html,body").animate({
            scrollTop: 0,
        });
    });
}

const checkbcrumbintroduce = () => {
    const pagesintro = $(".pages-introduce");
    const pagesProDetail = $(".pages-project-detail");
    const breadcrumb = $(".global-breadcrumb");
    if (pagesintro.length == 1) {
        breadcrumb.css("background-color", "#ffffff");
    } else if (pagesProDetail.length == 1) {
        breadcrumb.css("height", "auto");
    }
};

function headerMapping() {
    $("header .nav-desktop nav ul.nav-list li.nav-item").mapping({
        mobileWrapper: "header .nav-mobile ul.nav-list-mobile",
        mobileMethod: "appendTo",
        desktopWrapper: "header .nav-desktop nav ul.nav-list",
        desktopMethod: "appendTo",
        breakpoint: 1024,
    });
    $("header .tool-items").mapping({
        mobileWrapper: "header .nav-mobile nav",
        mobileMethod: "insertAfter",
        desktopWrapper: "header .header-info",
        desktopMethod: "insertBefore",
        breakpoint: 1024,
    });
    $("header .header-info .searchbox").mapping({
        mobileWrapper: "header .nav-mobile .tool-items",
        mobileMethod: "insertAfter",
        desktopWrapper: "header .header-info .wrapper #info_1",
        desktopMethod: "insertBefore",
        breakpoint: 1024,
    });
    $("header .header-info .information").mapping({
        mobileWrapper: "header .nav-mobile ul.nav-list-mobile",
        mobileMethod: "insertAfter",
        desktopWrapper: "header .header-info .wrapper ",
        desktopMethod: "appendTo",
        breakpoint: 1024,
    });
}

function sidebarProMapping() {
    $(".pages-product-list .col-lg-3.product-sidebar .wrap-acr ").mapping({
        mobileWrapper: "header .product-sidebar ",
        mobileMethod: "appendTo",
        desktopWrapper: ".pages-product-list .product-sidebar",
        desktopMethod: "appendTo",
        breakpoint: 992,
    });
}

function activeMobileMenusecond() {
    $(".nav-item").on("click", function(e) {
        e.stopPropagation();
        if ($(window).width() <= 1024) {
            $(this).addClass("active");
        }
    });
    $("#span_1").on("click", function() {
        if ($(window).width() <= 1024) {
            $(".nav-child-inner").addClass("active");
        }
    });
    $(".close-button #span_2").on("click", function(e) {
        e.stopPropagation();
        if ($(window).width() <= 1024) {
            $(".nav-child-inner").removeClass("active");
            if ($(".pages-product-list").length == 1) {
                $(this).parents(".nav-item").addClass("active");
            } else if ($(".product-detail-page").length == 1) {
                $(this).parents(".nav-item").addClass("active");
            } else {
                $(this).parents(".nav-item").removeClass("active");
            }
        }
    });
}

function MultiLevelAccordiion() {
    $(".nav-wrap .title").on("click", function() {
        $(this).siblings(".wrapper").slideToggle();
        $(this).toggleClass("active");
    });
    $(".label").click(function() {
        var label = $(this);
        var parent = label.parent(".has-children");
        var list = label.siblings("#list-child");
        if (parent.hasClass("is-open")) {
            list.slideUp("slow");
            parent.removeClass("is-open");
        } else {
            list.slideDown("slow");
            parent.addClass("is-open");
        }
    });
}

function tabAcordition() {
    $(".title-acr").click(function() {
        $(this).addClass("active").siblings(".title-acr").removeClass("active");
        var check = $(this).next().is(".active");
        var checkTitle = $(this).is(".active");
        if (check && checkTitle) {
            $(this).next().removeClass("active").slideUp();
            $(this).removeClass("active");
        } else {
            $(this)
                .next()
                .addClass("active")
                .slideDown()
                .siblings(".content-acr")
                .removeClass("active")
                .slideUp();
        }
    });
}

function removeLine() {
    var prolist = $(".pages-product-list");
    if (prolist.length == 1) {
        $(document).ready(function() {
            $(".title-acr").last().addClass("removeLine");
        });
    }
}

function toggleBrand() {
    $(".brand-wrapper").on("click", function() {
        $(this).toggleClass("active").siblings().removeClass("active");
    });
}

function changePlaceholder() {
    $(".wrap-form .frm-captcha-input input").attr("placeholder", "Nhập mã");
}

function autochangeActiveonClick() {
    var lienhe_address = document.getElementById("wrapper");
    var box_address = lienhe_address.getElementsByClassName("box");
    for (var i = 0; i < box_address.length; i++) {
        box_address[i].addEventListener("click", function() {
            var current = document.getElementsByClassName("active-2");
            current[0].className = current[0].className.replace(
                " active-2",
                ""
            );
            this.className += " active-2";
        });
    }
}

function expandRead() {
    $(".moreinfo").on("click", function() {
        $(this).toggleClass("active");
        $(".tab-content").toggleClass("active");
        if ($(".tab-content").is(".active")) {
            $(".moreinfo .wrapper p").text("Thu gọn");
        } else {
            $(".moreinfo .wrapper p").text("Xem thêm");
        }
    });
}

function ZoomImg() {
    if ($(window).width() >= 1200) {
        $(".swiper-slide-active .zoom-img").ezPlus({
            gallery: "gallery_01",
            cursor: "pointer",
            easing: "true",
            galleryActiveClass: "active",
            imageCrossfade: true,
            loadingIcon: "http://www.elevateweb.co.uk/spinner.gif",
            zoomWindowWidth: "534",
            zoomWindowHeight: "494",
            borderSize: "0",
            zoomWindowFadeIn: 500,
            zoomWindowFadeOut: 500,
            lensFadeIn: 500,
            lensFadeOut: 500,
            lensSize: 500,
        });
    }
}

function setBackgroundElement() {
    $("[setBackground]").each(function() {
        var background = $(this).attr("setBackground");
        $(this).css({
            "background-image": "url(" + background + ")",
            "background-size": "cover",
            "background-position": "center center",
        });
    });
    $("[setBackgroundRepeat]").each(function() {
        var background = $(this).attr("setBackgroundRepeat");
        $(this).css({
            "background-image": "url(" + background + ")",
            "background-repeat": "repeat",
        });
    });
}

function productFilter() {
    $(".product-sidebar-mobile .btn-cate").on("click", function() {
        $(".wrap-cate").toggleClass("active");
        $(".wrap-brand").removeClass("active");
    });
    $(".product-sidebar-mobile .btn-brand").on("click", function() {
        $(".wrap-brand").toggleClass("active");
        $(".wrap-cate").removeClass("active");
    });

    $(".close-button .wrapper-button").on("click", function() {
        $(".wrap-brand").removeClass("active");
        $(".wrap-cate").removeClass("active");
    });
}

function stickyNews_detail() {
    $(document).ready(function() {
        $(window).trigger("resize");
    });
    $(window).resize(function() {
        if ($(window).width() > 1024) {
            const bluenav = $(".nav-desktop").outerHeight() + 10;
            $(".orthernews-wrapper").css("top", bluenav);
        }
    });
}

function contentACR() {
    $(".content-acr").each(function() {
        if ($(this).hasClass("active")) {
            $(this).css("display", "block");
        }
    });
}

function changeMap() {
    $(".scroll-section")
        .find(".box")
        .click(function() {
            var datahref = $(this).attr("data-iframe");
            $(".map")
                .find("iframe")
                .attr("src", function() {
                    return datahref;
                });
        });
}

function DecoyImg() {
    $("img").attr(
        "onerror",
        "this.src='Data/Sites/1/skins/default/assets/no_img.jpg'"
    );
}
document.addEventListener("DOMContentLoaded", () => {
    DecoyImg();
    setBackgroundElement();
    expandRead();
    autochangeActiveonClick();
    removeLine();
    tabAcordition();
    navSlide();
    // activeHeaderWhenScroll();
    // checkScroll();
    CrMainBanner();
    ZoomImg();
    showBackToTop();
    collapse();
    scrollToDiv();
    headerMapping();
    activeMobileMenusecond();
    checkLayoutBanner();
    phantrang();
    changePlaceholder();
    toggleBrand();
    productFilter();
    stickyNews_detail();
    contentACR();
    changeMap();
});
